module.exports = __webpack_public_path__ + "img/angststoerungen_1280.3892af4f.png";